import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import "./scroll-to-top.css";

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);

        return () => {
            window.removeEventListener("scroll", toggleVisibility);
        };
    }, []);

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <>
            {isVisible && (
                <button
                    className="scroll-to-top-btn"
                    onClick={handleClick}
                    aria-label="العودة للأعلى"
                >
                    <FaArrowUp className="scroll-icon" />
                    <div className="scroll-progress-ring">
                        <svg className="progress-ring" width="60" height="60">
                            <circle
                                className="progress-ring-circle"
                                stroke="currentColor"
                                strokeWidth="3"
                                fill="transparent"
                                r="25"
                                cx="30"
                                cy="30"
                            />
                        </svg>
                    </div>
                </button>
            )}
        </>
    );
};

export default ScrollToTop;